interface HashTable<T> {
    [key: string]: T;
}

export class Messages {
    public messagesMap: HashTable<string>;

    constructor() {
        this.buildErrorList();
    }

    private buildErrorList() {
        this.messagesMap = {};

        this.messagesMap['empty_card_number'] = 'El número de tarjeta está vacío';
        this.messagesMap['empty_card_holder_name'] = 'El nombre del titular de la tarjeta está vacío';
        this.messagesMap['nan_card_number'] = 'El número de tarjeta debe ser un número';
        this.messagesMap['invalid_card_number'] = 'Número de tarjeta inválido';
        this.messagesMap['invalid_expiry_date'] = 'La fecha de caducidad no es válida';
        this.messagesMap['empty_token'] = '';
        this.messagesMap['invalid_param'] = 'Parámetros inválidos.';

        this.messagesMap['invalid_number'] = 'No pudimos procesar tu pago,  Revisa el número de tarjeta.';
        this.messagesMap['security_code_error'] = 'No pudimos procesar tu pago,   Revisa el código de seguridad. ';
        this.messagesMap['expired_card'] = 'No pudimos procesar tu pago,  Revisa la fecha de vencimiento. ';
        this.messagesMap['insufficient_amount'] = 'No pudimos procesar tu pago, Tu tarjeta no tiene fondos suficientes. ';

        this.messagesMap['request_authorization_card'] = 'No pudimos procesar tu pago, revisa los datos ingresados';
        this.messagesMap['cybersource_error'] = 'No pudimos procesar tu pago, revisa los datos ingresados';
        this.messagesMap['group_rejected'] = 'No pudimos procesar tu pago, revisa los datos ingresados';
        this.messagesMap['card_declined'] = 'No pudimos procesar tu pago, revisa los datos ingresados';
        this.messagesMap['processing_error'] = 'No pudimos procesar tu pago, revisa los datos ingresados';
        this.messagesMap['invalid_card'] = 'No pudimos procesar tu pago, revisa los datos ingresados';

        this.messagesMap['decidir_exception'] = 'Hubo un error al realizar el pago, intentá nuevamente';
        this.messagesMap['general_exception'] = 'Error en realizar la operación, intente nuevamente';
        this.messagesMap['awpe_exception'] = 'Tu pago fue aprobado, pero hubo un error en la confirmación';
    }

    public getMessage(key: string) {
        return this.messagesMap[key];
    }

    public getSuggestedMessage(key: string, params: any) {
        let message: string = this.messagesMap[key] || '';
        if (params) {
            message = message.replace(/payment_method_id/g, this.capitalizeFirstLetter(params.payment_method_id));
            message = message.replace(/amount/g, params.amount);
            message = message.replace(/installments/g, params.installments);
            message = message.replace(/installments/g, params.installments);
        }
        return message;
    }

    private capitalizeFirstLetter(text: string) {
        if (text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }
        return '';
    }

    public getErrorDescription(code: any) {
        let errorMsg = `${code}-`;
        switch (code) {
            case '777':
            case '888':
                errorMsg += 'Demoras en Procesar tu Pago';
                break;
            case '1':
            case '2':
            case '4':
            case '5':
            case '7':
            case '43':
            case '58':
            case '76':
            case '89':
            case '94':
                errorMsg += 'Pago no Autorizado';
                break;
            case '0':
            case '3':
            case '999':
            case '13':
            case '19':
            case '25':
            case '30':
            case '95':
            case '96':
            case '97':
            case '98':
                errorMsg += 'Error de Sistema';
                break;
            case '8':
            case '39':
                errorMsg += 'Datos Ingresados Incorrectos';
                break;
            case '12':
                errorMsg += 'No se pudo Procesar la Transacción';
                break;
            case '14':
                errorMsg += 'Numero de Tarjeta No Válido';
                break;
            case '28':
            case '31':
                errorMsg += 'Inconveniente Técnico al Procesar el Pago';
                break;
            case '38':
                errorMsg += 'Superó Límite de Intentos de Verificación de PIN';
                break;
            case '45':
                errorMsg += 'No se Autorizaron Cuotas';
                break;
            case '46':
                errorMsg += 'Tarjeta Inactiva';
                break;
            case '47':
                errorMsg += 'Tarjeta Requiere PIN';
                break;
            case '48':
                errorMsg += 'Tarjeta Superó Limite de Cuotas';
                break;
            case '49':
                errorMsg += 'Fecha Vencimiento de Tarjeta Incorrecta';
                break;
            case '50':
            case '61':
            case '65':
                errorMsg += 'Tarjeta Superó Monto Límite';
                break;
            case '51':
                errorMsg += 'Fondos Insuficientes';
                break;
            case '53':
                errorMsg += 'Tarjeta no tiene Cuenta Bancaria Asociada';
                break;
            case '54':
                errorMsg += 'Tarjeta Vencida';
                break;
            case '55':
                errorMsg += 'Pago no Autorizado Problemas de Identificación';
                break;
            case '56':
                errorMsg += 'Inhabilitado para realizar la Transacción';
                break;
            case '57':
                errorMsg += 'Tarjeta No Habilitada para Realizar el Pago';
                break;
            case '77':
                errorMsg += 'Plan de Cuotas Seleccionada No Válido';
                break;
            case '91':
                errorMsg += 'No se Puede Autorizar el Pago';
                break;
            case '400':
            case '400m<':
            case '404':
            case '500':
            case undefined:
            case '-1':
            case '12035':
            case '41':
            case '10005':
            case '15':
            case '9999':
                errorMsg += 'Error No Tipificado';
                break;

            default:
                errorMsg = 'MI RENTAS | Formulario de pago';
                break;
        }
        return errorMsg;
    }
}

// tslint:disable-next-line: max-line-length
export const DEFAULT_MESSAGE_ERROR = `Disculpá, tuvimos un error de sistema. Estamos trabajando para resolverlo. Intentá de nuevo en unos minutos. Si continua por favor comunícate con nosotros.`;
